/**
 * Buy Now Button Functionality
 * Clears cart and redirects directly to checkout with selected product
 */
document.addEventListener('DOMContentLoaded', function() {
  const buyNowButtons = document.querySelectorAll('[data-action="buy-now"]');
  
  buyNowButtons.forEach(button => {
    button.addEventListener('click', async function(event) {
      event.preventDefault();
      
      // Disable button and show loading state
      button.setAttribute('disabled', 'disabled');
      button.classList.add('Button--loading');
      
      try {
        // 1. Clear the cart first
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        // 2. Get form data from the product form
        const form = button.closest('form');
        const formData = new FormData(form);
        const formObject = {};
        
        // Convert FormData to regular object
        for (let [key, value] of formData.entries()) {
          formObject[key] = value;
        }
        
        // 3. Add the selected variant to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(formObject)
        });
        
        if (!response.ok) {
          throw new Error('Failed to add product to cart');
        }
        
        // 4. Redirect to checkout
        window.location.href = '/checkout';
      } catch (error) {
        console.error('Buy Now Error:', error);
        
        // Show error message
        const errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
        errorMessageElement.innerHTML = 'There was an error processing your purchase. Please try again.';
        
        button.removeAttribute('disabled');
        button.classList.remove('Button--loading');
        button.insertAdjacentElement('afterend', errorMessageElement);
        
        setTimeout(() => {
          errorMessageElement.remove();
        }, 3000);
      }
    });
  });
});
